import { purchaseOrderRoutes } from './purchase-orders';
import { billingOrderRoutes } from './billing-orders';
import { newUserRoutes } from './new-user';

export const approvalFlowRoutes = [
  {
    path: 'approval-flow',
    children: [...purchaseOrderRoutes, ...billingOrderRoutes, ...newUserRoutes],
  },
];
